<template>
  <div id="app" v-cloak>
    <!-- <div id="nav"> -->
    <!-- <router-link to="/home">Home</router-link>|
      <router-link to="/about">About</router-link>|
    <router-link to="/home/teacher">teacher</router-link>-->
    <!-- <router-view/> -->
    <!-- </div> -->
    <router-view />
  </div>
</template>
<script>
import {getCookie} from '@/utils/util';
export default {
  created() {
    // window.BackPage = undefined;
    // window.goBack = function() {
    //   if (typeof window.BackPage == "undefined") {
    //     if (window.navigator.userAgent.match(/iPhone/)) {
    //       window.location = "goWhere:";
    //       return 1;
    //     }
    //     window.eastmoney.goWhere();
    //   } else {
    //     window.location = window.BackPage;
    //     return 1;
    //   }
    // };
    // const isMaintain = getCookie('isPaidvideoBuild');
    // if (!isMaintain) {
    //     window.location.href = 'https://premium.eastmoney.com/FrontEndLib/emlib/other/build.html';
    // }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #fff;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
  font-size: 0.24rem;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
[v-cloak] {
  display: none;
}
</style>
